import axios from 'axios';

export const normalizeRuntimeConfigs = runtimeConfig => {
  if (!runtimeConfig) {
    return null;
  }

  return {
    appVersion:
      runtimeConfig.appVersion ||
      runtimeConfig.APP_VERSION ||
      runtimeConfig.version ||
      runtimeConfig.VERSION ||
      '',
    apiUrl: runtimeConfig.apiUrl || runtimeConfig.API_URL || '',
    hubUrl: runtimeConfig.hubUrl || runtimeConfig.HUB_URL || '',
    cdnUrl: runtimeConfig.cdnUrl || runtimeConfig.CDN_URL || '',
    cdnKey: runtimeConfig.cdnKey || runtimeConfig.CDN_KEY || '',
    portalBpmUrl:
      runtimeConfig.portalBpmUrl || runtimeConfig.PORTAL_BPM_URL || '',
    defaultTheme:
      runtimeConfig.defaultTheme || runtimeConfig.DEFAULT_THEME || '',
    theme: runtimeConfig.theme || runtimeConfig.THEME || runtimeConfig.defaultTheme || runtimeConfig.DEFAULT_THEME || '',
    activePortals:
      runtimeConfig.activePortals || runtimeConfig.ACTIVE_PORTALS || [],
    defaultLogin:
      runtimeConfig.defaultLogin || runtimeConfig.DEFAULT_LOGIN || '',
    themes: runtimeConfig.themes || runtimeConfig.THEMES || null,
    hubUrlCommunication:
      runtimeConfig.hubUrlCommunication ||
      runtimeConfig.HUB_URL_COMMUNICATION ||
      '',
    hubUrlImport:
      runtimeConfig.hubUrlImport || runtimeConfig.HUB_URL_IMPORT || '',
    hubUrlAuth:
      runtimeConfig.hubUrlAuth || runtimeConfig.HUB_URL_AUTH || '',
    hubUrlAdmin:
      runtimeConfig.hubUrlAdmin || runtimeConfig.HUB_URL_ADMIN || '',
    hubUrlIntegration:
      runtimeConfig.hubUrlIntegration ||
      runtimeConfig.HUB_URL_INTEGRATION ||
      '',
  };
};

export const runtimeConfigs = async () => {
  return axios
    .get('/static/config.json')
    .then(response => {
      return normalizeRuntimeConfigs(response.data);
    })
    .catch(() => {
      return null;
    });
};
